








import { Vue } from 'vue-property-decorator'
import ScreenTile from '../components/ScreenTile.vue'

export default Vue.extend({
  components: { ScreenTile },
})
